// @ts-nocheck

import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

export const generateInviteToken = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

export const sendRosterInvitation = async (
  teamId: string,
  rosterId: string,
  rosterData: {
    first_name: string;
    last_name: string;
    email: string;
    cell_phone?: string;
  },
  teamName: string,
  coachName: string,
  invitedByUserId: string
) => {
  try {
    console.log('🚀 [ROSTER-INVITATION] Starting invitation process for:', rosterData.email);
    
    // Send comprehensive invitation via enhanced edge function
    const { data, error } = await invokeEdgeFunction('send-roster-invitation', {
      body: {
        athlete_email: rosterData.email,
        athlete_name: `${rosterData.first_name} ${rosterData.last_name}`,
        athlete_phone: rosterData.cell_phone,
        team_name: teamName,
        coach_name: coachName,
        team_id: teamId,
        roster_id: rosterId,
        invited_by_user_id: invitedByUserId
      }
    });

    if (error) {
      console.error('❌ [ROSTER-INVITATION] Error sending invitation:', error);
      throw new Error(`Failed to send invitation: ${error.message}`);
    }

    console.log('✅ [ROSTER-INVITATION] Invitation process completed:', data);

    return { 
      success: true, 
      results: data?.results || {},
      message: 'Multi-channel invitation sent successfully'
    };
  } catch (error) {
    console.error('❌ [ROSTER-INVITATION] Error in sendRosterInvitation:', error);
    throw error;
  }
};